module.exports = __webpack_public_path__ + "img/fbb6a7b.png";